import React, {Component} from 'react';
import {Alert, Col, Row} from "reactstrap";
import {Button, Spinner} from "react-bootstrap";

class TelegramComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            send_text: '',
            successForm: false,
            successFormMessage: '',
            loadingSendMail: false,
            disableButtonSendMail: false
        }
    }

    render() {
        return (
            <>
                <Row className="form-group">
                    <Col md={2} className="col-form-label">
                        <label htmlFor="telegram_url">Url</label>
                    </Col>
                    <Col md={10}>
                        <input type="text" value={ this.props.telegram.telegram_url } onChange={this.props.onChangeValue} className="form-control" id="telegram_url" name="telegram_url" placeholder="Đường dẫn" />
                    </Col>
                </Row>
                <Row className="form-group">
                    <Col md={2} className="col-form-label">
                        <label htmlFor="telegram_token">Token</label>
                    </Col>
                    <Col md={10}>
                        <input type="text" value={ this.props.telegram.telegram_token } onChange={this.props.onChangeValue} className="form-control" id="telegram_token" name="telegram_token" placeholder="Token" />
                    </Col>
                </Row>
                <Row className="form-group">
                    <Col md={2} className="col-form-label">
                        <label htmlFor="telegram_chat_id">Chat ID</label>
                    </Col>
                    <Col md={10}>
                        <input type="text" value={ this.props.telegram.telegram_chat_id } onChange={this.props.onChangeValue} className="form-control" id="telegram_chat_id" name="telegram_chat_id" placeholder="Chat ID" />
                    </Col>
                </Row>
                <Row>
                    <Col id="send-telegram-test">
                        {
                            this.state.errorForm ? (
                                <Col className="px-0">
                                    <Alert color="danger">
                                        { this.state.errorFormMessage }
                                    </Alert>
                                </Col>
                            ) : (
                                <></>
                            )
                        }
                        {
                            this.state.successForm ? (
                                <Col className="px-0">
                                    <Alert color="success">
                                        { this.state.successFormMessage }
                                    </Alert>
                                </Col>
                            ) : (
                                <></>
                            )
                        }
                        <h5>Kiểm tra liên kết telegram</h5>
                        <Row className="form-group mb-0">
                            <Col md={2} className="col-form-label">
                                <label htmlFor="send_text">Gửi tin nhắn</label>
                            </Col>
                            <Col md={10}>
                                <input type="text" className="form-control" id="send_text" name="send_text" onChange={ (e) => { this.setState({ send_text: e.target.value }) } } placeholder="Gửi tin nhắn" />
                            </Col>
                            <Col className="mb-0">
                                <Button variant="primary"
                                        size="sm"
                                        disabled={this.state.disableButtonSendMail}
                                        onClick={ this.testSendMail }
                                >
                                    {
                                        this.state.loadingSendMail ? (
                                            <Spinner
                                                as="span"
                                                animation="grow"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"

                                            />
                                        ) : (
                                            <></>
                                        )
                                    }
                                    Kiểm tra
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </>
        );
    }
}

export default TelegramComponent;